import { HelmetProvider } from 'react-helmet-async';

import { RouterProvider } from '@tanstack/react-router';

import './App.css';

import { useTrackingInstallion } from '@/tracking/Tracking.hooks';

import { router } from './App.router';
import { Assets } from '@/assets';

function App() {
	useTrackingInstallion();

	const classNames = ['App'];
	/*if (config.app.contentProtection) {
		classNames.push('content-protection');
	}*/

	return (
		<Assets>
			<HelmetProvider>
				<div className={classNames.join(' ')}>
					<RouterProvider router={router} />
				</div>
			</HelmetProvider>
		</Assets>
	);
}

export default App;
